module.exports = __webpack_public_path__ + "img/Compact-SR_Overview-Rear_2.2b89e062.jpg";